module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDwhLS0gVE9ETyB0aGlzIHZpZXdCb3ggbWlnaHQgbm90IG1hdGNoIHRoZSBwYXRoIGRpbWVuc2lvbnMgLS0+CiAgICA8c3ltYm9sIGlkPSJhcmMiIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+CiAgICAgIDxkZXNjPmFyYzwvZGVzYz4KICAgICAgPHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiCgkJZD0ibTk5LjUsNTBjMCwyNy4zMzgzNDEgLTIyLjE2MjExNyw0OS41IC00OS41LDQ5LjVzLTQ5LjUsLTIyLjE2MTY1OSAtNDkuNSwtNDkuNSIvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/arc.svg
// module id = 696
// module chunks = 0